module.exports = __webpack_public_path__ + "img/image-style-06.3f0db3cf.svg";